import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseUpdateCategoryComponent } from "../utils/types";
import { queryClient } from "../App";

const useUpdateCategoryComponentVisiblity = (): IUseUpdateCategoryComponent =>
    useMutation({
        mutationFn: async (data: any) => {
            const response = await AXIOS_RESERVATION.put(`v1/update-category-component-visibility`, data);
            return response.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["services-components"] });
        },
    });

export default useUpdateCategoryComponentVisiblity;
